<template>
    <div>
        <label>
            <small
                v-show="isRequired"
                class="text-danger"
            >*</small> {{ label }}:
        </label>
        <b-form-group v-slot="{ name }">
            <b-form-radio-group
                v-model="localValue"
                :options="listOptions"
                :aria-describedby="name"
                :name="name"
                :required="isRequired"
                stacked
            ></b-form-radio-group>
        </b-form-group>
    </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxRadioButton',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    listOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    initialValue: {
      type: Number,
      required: false
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = null
    })
  },
  mounted () {
    if (this.initialValue !== undefined && this.initialValue !== null) {
      this.localValue = this.initialValue
    }
  },
  methods: {
    updateLocalValue (newValue) {
      this.localValue = newValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/buttons/NxRadioButton.vue